if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        refreshCartDrawer();
      }
   }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const quantityInputs = document.querySelectorAll('.quantity__input');

  quantityInputs.forEach(input => {
    input.addEventListener('input', function () {
      const max = parseInt(this.getAttribute('max'), 10);
      const errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper');
      const errorMessage = errorMessageWrapper?.querySelector('.product-form__error-message');

      if (this.value > max) {
        this.value = max; // Set the value to the max if it exceeds the max

        // Display the error message
        if (errorMessageWrapper && errorMessage) {
          errorMessageWrapper.removeAttribute('hidden');
          errorMessage.textContent = `We only have ${max} in stock.`;
        }
      } else {
        // Hide the error message if the value is valid
        if (errorMessageWrapper) {
          // errorMessageWrapper.setAttribute('hidden', true);
        }
      }
    });
  });
});

function refreshCartDrawer() {
  fetch(window.routes.cart_url + '?section_id=cart-drawer')
    .then(res => res.text())
    .then(html => {
      const cartElement = document.querySelector('cart-drawer');
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const cartHTML = doc.querySelector('cart-drawer');

      if (cartHTML) {
        cartElement.innerHTML = cartHTML.innerHTML;
        cartElement.classList.remove('is-empty');
        cartElement.classList.add('active'); // 👈 use 'active' instead of 'is-visible'
        document.body.classList.add('overflow-hidden');

        // ✅ UI cleanup
        /* submitButton?.removeAttribute('aria-disabled');
        submitButton?.classList.remove('loading');
        scope.querySelector('.loading-overlay__spinner')?.classList.add('hidden'); */
      }
    });
}
